'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const StoryblokContext = /*#__PURE__*/ createContext(null);
const StoryblokProvider = ({ children, onPublished })=>{
    return /*#__PURE__*/ jsx(StoryblokContext.Provider, {
        value: {
            onPublished
        },
        children: children
    });
};
const useStoryblokContext = ()=>{
    return useContext(StoryblokContext);
};

export { StoryblokProvider as S, useStoryblokContext as u };
